<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { env } from '@/secrets/env'
import { useI18n } from 'vue-i18n'
import { $router } from '@/router'
import { $bus } from '@/common/events'
import { dialog } from '@/common/dialog'
import { formatTime, formatLocaleDate, formatLocaleTime } from '@/common/format'
import { useRuntime } from '@/composables/runtime'
import { useTitle } from '@/composables/title'
import { useMenu, useSubmenu, useTopBar } from '@/composables/menu'
import { useAuthState } from '@/composables/auth'
import { ConfigService } from '@/services/ConfigService.js'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import DropDown from '@/components/DropDown.vue'
import CheckBox from '@/components/CheckBox.vue'
import TextBox from '@/components/TextBox.vue'
import Button from '@/components/Button.vue'
import Label from '@/components/Label.vue'

const runtime = useRuntime();
const { uptime } = useRuntime();

const uptimeText = ref();

const time = ref("");

let timer = null;

const rows = ref([ ]);

const version = ref(env.VITE_SEMVER);
const buildTime = computed(() => env.BUILD_TIME ? new Date(env.BUILD_TIME) : null);

onMounted(async () => {
  useTitle("O programu");
  useMenu("admin");
  useSubmenu(false);
  useTopBar(true);

  loadVariables();

  timer = setInterval(() => {
    uptimeText.value = formatTime(uptime());
  }, 1000);
});

onUnmounted(async () => {
  if (timer) {
    clearInterval(timer);
  }
});

function loadVariables() {
  let list = [ ];
  list.push({ name: "Developed by", value: "PLT d.o.o." });
  list.push({ name: "Contact info", value: "info@plt.si" });
  if (runtime.startup.value) {
    list.push({ name: "Vue mounted", value: formatLocaleDate(runtime.startup.value) + " " + formatLocaleTime(runtime.startup.value), uptime: true });
  }
  if (buildTime.value) {
    list.push({ name: "Build time", value: formatLocaleDate(buildTime.value) + " " + formatLocaleTime(buildTime.value) });
  }
  list.push({ name: "Version", value: version });
  if (runtime.version) {
    //list.push({ name: "Version", value: runtime.name + " v" + runtime.version });
    list.push({ name: "git commit", value: runtime.gitBranch + " " + runtime.gitCommit });
    //list.push({ name: "Build time", value: runtime.buildDate + " " + runtime.buildTime });
  }
  rows.value = list;
}

function goBack() {
  try {
    $router.push({ name: "Admin" });
  }
  catch (err) {
    dialog(err);
  }
}
</script>

<template>
  <div class="dark:bg-gray-900 dark:text-white p-5">
    
    <div class="flex justify-between">
      <h2 class="text-lg font-bold dark:text-white">{{ $t('admin.about_title') }}</h2>
      <div class="flex flex-row gap-4">
        <Button type="secondary" @click="goBack()">{{ $t('generic.back') }}</Button>
      </div>
    </div>

    <form autocomplete="off">

      <!-- Application info -->
      <div class="interactive-table w-full mt-4">
        <Table :rows="rows">
          <template #header>
            <th scope="col" class="pl-4 pr-2 py-3">{{ $t('admin.description') }}</th>
            <th scope="col" class="pr-4 pl-2 py-3">{{ $t('admin.value') }}</th>
          </template>
          <template #row="row">
            <td class="pl-4 pr-2 py-2 font-medium whitespace-nowrap">
              <span>{{ row.name }}</span>
            </td>
            <td class="px-2 py-2 whitespace-nowrap">
              <span v-if="row.value">{{ row.value }}</span>
              <span v-else>--</span>
              <!-- <span v-if="row.uptime" class="ml-2 text-slate-400"><i class="fa fa-clock fa-regular"></i> {{ uptimeText }}</span> -->
            </td>
          </template>
        </Table>
      </div>

    </form>
  </div>
</template>

<style scoped>
</style>
